import { VONS } from "../../VO/VONS.js";
export class BackgroundImageValue {
  constructor({ url, data_url, opacity }) {
    this._url = url;
    this._data_url = data_url;
    this._opacity = opacity;
  }
  toVO() {
    return {
      type: "image",
      url: this._url,
      data_url: this._data_url,
      opacity: this._opacity,
    };
  }
}
